import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgInformationIcon = (props, ref) => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <circle cx={8} cy={8} r={5} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={8} cy={5.75} r={0.75} fill="currentColor" />
    <path d="M8 8v3" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" />
  </svg>
);

const ForwardRef = forwardRef(SvgInformationIcon);
const Memo = memo(ForwardRef);
export default Memo;
